import React, { useState, useEffect, useContext } from 'react'
import {
    Form,
    Button,
    Row,
    Col,
    Input,
    Card,
    CardBody,
    FormGroup,
    Label,
    CardTitle,
    CardSubtitle
} from "reactstrap"

import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import { GeneralContext } from '../../../context'
import ApiService from '../../../data/services/ApiService'
import { withRouter } from 'react-router-dom'
import { validateRFC } from '../../../components/Global/helpers'

const FormPage = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext

    const [id, setId] = useState()
    const [fullName, setFullName] = useState('')
    const [dob, setDOB] = useState('')
    const [businessName, setBusinessName] = useState('')
    const [taxId, setTaxId] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [countryCode, setCountryCode] = useState('')

    useEffect(() => {
        if (props.data !== undefined) { 
            const { data } = props

            setId(data.id)
            setTaxId(data.taxId || '')
            setDOB(data.dob || '')
            setFullName(data.fullName || '')
            setBusinessName(data.businessName || '')
            setEmail(data.email || '')
            setPhone(data.phone || '')
            setCountryCode(data.countryCode || '')
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.data])

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!_validateForm()) {
            toastr.error('No olvides llenar los campos.', 'Error')

            return
        }

        setLoading(true)

        let data = {
            businessName,
            fullName,
            dob,
            taxId,
            email,
            phone,
            countryCode
        }

        if (props.data !== undefined) { 
            _updateCustomer({ ...data, id })

            return false
        }
        
        _createCustomer(data)
        
        props.history.push('/customers')
    }

    const _createCustomer = async (data) => {
        setLoading(true)

        try {
            const response = await ApiService.createCustomer(data)

            if (!response.data.success) {
                toastr.error(`No pude crear a ${fullName}.`, 'Error')

                return false
            }

            toastr.success(`Cliente agregado`, '¡Éxito!')
            window.analytics.track('New customer addedd', {
                data
            })
        } catch(error) {
            toastr.error(`No pude crear a ${fullName}.`, 'Error')
        } finally {
            setLoading(false)
        }
    }

    const _updateCustomer = async (data) => {
        setLoading(true)

        try {
            const response = await ApiService.updateCustomer(data)

            if (!response.data.success) {
                toastr.error(`No pude editar a ${fullName}.`, 'Error')

                return false
            }

            toastr.success(`Cliente Actualizado`, `Éxito`)
            window.analytics.track(`Customer Updated`, {
                data
            })
        } catch(error) {
            toastr.error(`No pude editar a ${fullName}.`, 'Error')
        } finally {
            setLoading(false)
        }
    }

    const _validateForm = () => {
        if (fullName === '') { return false }
        if (email === '') { return false }
        if (phone === '') { return false }

        if (taxId && !validateRFC(taxId)) {
            toastr.error(`El RFC que ingresaste no es válido`, 'Error')
            document.getElementById('rfc').style.border = '1px solid red'

            return false
        }

        return true
    }

    return(
        <React.Fragment>
            <Form id="create" method="POST" onSubmit={ handleSubmit }>
                <Row>
                    <Col xs={12}>
                        <Card style={{textAlign: 'right'}}>
                            <CardBody>
                                <Button
                                    onClick={() => { window.history.go(-1) }}
                                    className="btn btn-secondary btn-rounded waves-effect waves-light mb-2 mr-2"
                                >
                                    Cancelar
                                </Button>

                                <Button
                                    type="submit"
                                    color="primary"
                                    className="btn btn-primary btn-rounded waves-effect waves-light mb-2 mr-2"
                                >
                                    <i className={`mdi mdi-check`}></i> Guardar
                                </Button>
                            </CardBody>
                        </Card>

                        <Card>
                            <CardBody>
                                <Row>
                                    <Col sm={4} xs={12}>
                                        <CardTitle>
                                            Información General
                                        </CardTitle>
                                        <CardSubtitle className="mb-3">
                                            Agrega los datos generales de tu cliente.
                                        </CardSubtitle>
                                    </Col>
                                    <Col sm={8} xs={12}>
                                        <Row>
                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label>
                                                        Nombre *
                                                    </Label>
                                                    <Input
                                                        id="fullName"
                                                        type="text"
                                                        className="form-control"
                                                        value={fullName}
                                                        required
                                                        onChange={event => setFullName(event.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label>
                                                        Email *
                                                    </Label>
                                                    <Input
                                                        id="email"
                                                        type="email"
                                                        className="form-control"
                                                        value={email}
                                                        onChange={event => setEmail(event.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label>
                                                        Código de País
                                                    </Label>
                                                    <Input
                                                        id="countryCode"
                                                        type="text"
                                                        className="form-control"
                                                        value={countryCode}
                                                        onChange={event => setCountryCode(event.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label>
                                                        Teléfono *
                                                    </Label>
                                                    <Input
                                                        id="phone"
                                                        type="text"
                                                        className="form-control"
                                                        value={phone}
                                                        onChange={event => setPhone(event.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Form>
        </React.Fragment>
    )
}

export default withRouter(FormPage)
